import { defineComponent as _defineComponent } from 'vue'
import { __ } from 'bits/intl'
import ImageThumbnail from 'library/v4/components/ImageThumbnail.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzIconButton, { OzIconButtonColorScheme, OzIconButtonSizePreset } from 'library/v4/components/OzIconButton.vue'
import OzPlainButton, {
  OzPlainButtonColorScheme,
  OzPlainButtonSizePreset,
} from 'library/v4/components/OzPlainButton.vue'
import { storeToRefs } from 'pinia'
import { useDarkModeStore } from 'pinia/dark_mode'
import { useWindowSizeStore } from 'pinia/window_size'
import LandsideFooterSection, { LandsideNavigation } from 'vuecomponents/LandsideFooterSection.vue'
import LocaleSelector from 'vuecomponents/LocaleSelector.vue'
import PadletLogo, { LogoType } from 'vuecomponents/PadletLogo.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandsideFooter',
  props: {
  xIllustration: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



const { windowWidth } = storeToRefs(useWindowSizeStore())
const { isDarkMode } = storeToRefs(useDarkModeStore())

const footerIllustrationDarkUrl = 'https://padlet.net/homepage/v1/footer_illustration_dark.png'
const footerIllustrationLightUrl = 'https://padlet.net/homepage/v1/footer_illustration_light.png'
const ILLUSTRATION_ORIGINAL_IMAGE_WIDTH = 5760
const ILLUSTRATION_ORIGINAL_IMAGE_HEIGHT = 550

const socialMediaIcons = [
  { icon: 'youtube_outline', url: 'https://www.youtube.com/@padlet', label: 'Youtube' },
  { icon: 'twitter_outline', url: 'https://twitter.com/padlet', label: 'Twitter' },
  { icon: 'facebook_outline', url: 'https://www.facebook.com/padlet/', label: 'Facebook' },
  { icon: 'instagram_outline', url: 'https://www.instagram.com/padlet', label: 'Instagram' },
  { icon: 'linkedin_outline', url: 'https://www.linkedin.com/company/padlet', label: 'Linkedin' },
]

const productNavigationItems: LandsideNavigation[] = [
  { name: __('Features'), url: 'https://www.padlet.com/features' },
  { name: __('Apps and Integration'), url: 'https://www.padlet.com/about/apps' },
  { name: __('What’s new'), url: 'https://padlet.blog/' },
]

const membershipsNavigationItems: LandsideNavigation[] = [
  { name: __('Personal'), url: 'https://www.padlet.com/memberships#personal' },
  { name: __('Business'), url: 'https://www.padlet.com/memberships#business' },
  { name: __('Schools'), url: 'https://www.padlet.com/memberships#school' },
]

const companyNavigationItems: LandsideNavigation[] = [
  { name: __('Company'), url: 'https://www.padlet.com/about/us' },
  { name: __('Jobs'), url: 'https://www.angel.co/company/padlet/jobs' },
  { name: __('Twitter'), url: 'https://www.twitter.com/padlet' },
]

const supportNavigationItems: LandsideNavigation[] = [
  { name: __('Knowledge'), url: 'https://www.padlet.help' },
  { name: __('Video tutorials'), url: 'https://www.youtube.com/padlet' },
  { name: __('Examples'), url: 'https://www.padlet.com/gallery' },
  { name: __('Contact us'), url: 'https://www.padlet.com/contact-us' },
]

const legalNavigationItems: LandsideNavigation[] = [
  { name: __('Terms of use'), url: 'https://legal.padlet.com/terms' },
  { name: __('Privacy policy'), url: 'https://legal.padlet.com/privacy' },
  { name: __('Content policy'), url: 'https://legal.padlet.com/content' },
  { name: __('Accessibility statement'), url: 'https://legal.padlet.com/accessibility' },
]

return { __sfc: true,windowWidth, isDarkMode, footerIllustrationDarkUrl, footerIllustrationLightUrl, ILLUSTRATION_ORIGINAL_IMAGE_WIDTH, ILLUSTRATION_ORIGINAL_IMAGE_HEIGHT, socialMediaIcons, productNavigationItems, membershipsNavigationItems, companyNavigationItems, supportNavigationItems, legalNavigationItems, __, ImageThumbnail, OzIcon, OzIconButton, OzIconButtonColorScheme, OzIconButtonSizePreset, OzPlainButton, OzPlainButtonColorScheme, OzPlainButtonSizePreset, LandsideFooterSection, LocaleSelector, PadletLogo, LogoType }
}

})